// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1iDqx","modalFooterButton":"ModalNotes_modalFooterButton__1dWn0"};